import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    CreateTaskMessageTemplateCategoryInput,
    TaskMessageTemplateCategoryFilterInput,
    UpdateTaskMessageTemplateCategoryInput,
} from './inputs';
import { TaskMessageTemplateCategoryRef } from './refs';
import { TaskMessageTemplateCategoryResource, TaskMessageTemplateCategoryListItemResource } from './resources';

export default class TaskMessageTemplateCategory {
    private basePath = '/api/task-message-template-category';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get task message template category list
    get = async (
        filter?: TaskMessageTemplateCategoryFilterInput
    ): Promise<CollectionResource<TaskMessageTemplateCategoryListItemResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single task message template category
    getById = async (id: ID): Promise<TaskMessageTemplateCategoryResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Create new task message template category
    create = async (input: CreateTaskMessageTemplateCategoryInput): Promise<TaskMessageTemplateCategoryRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update task message template category
    update = async (id: ID, input: UpdateTaskMessageTemplateCategoryInput): Promise<TaskMessageTemplateCategoryRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive task message template category
    archive = async (id: ID): Promise<TaskMessageTemplateCategoryRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived task message template category
    restore = async (id: ID): Promise<TaskMessageTemplateCategoryRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);

        return data;
    };
}
